import React, { FC } from 'react';
import Pagination, { Props } from './Pagination';
import { useRenderers } from '../../../../../renderProps';

const PaginationWithOverride: FC<Props> = props => {
	const { Pagination: PaginationOverride = Pagination } = useRenderers();

	return <PaginationOverride {...props} />;
};

export default PaginationWithOverride;
